"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClerkCatchBoundary = void 0;
const tslib_1 = require("tslib");
const react_1 = require("@remix-run/react");
const react_2 = tslib_1.__importDefault(require("react"));
const Interstitial_1 = require("./Interstitial");
function ClerkCatchBoundary(RootCatchBoundary) {
    return () => {
        var _a;
        const { data } = (0, react_1.useCatch)();
        const { __clerk_ssr_interstitial_html } = ((_a = data === null || data === void 0 ? void 0 : data.clerkState) === null || _a === void 0 ? void 0 : _a.__internal_clerk_state) || {};
        if (__clerk_ssr_interstitial_html) {
            return react_2.default.createElement(Interstitial_1.Interstitial, { html: __clerk_ssr_interstitial_html });
        }
        if (!RootCatchBoundary) {
            return undefined;
        }
        return react_2.default.createElement(RootCatchBoundary, null);
    };
}
exports.ClerkCatchBoundary = ClerkCatchBoundary;
